// TODO: Deprecate this file in favor of./creationTool/oeqReducer
// where oeq is independent from the presentation entity
// and uses the new microservices architecture

import actionTypes from 'redux/actions/actionTypes'
import makeUniqueId from 'helpers/makeUniqueId'
import { getFlag } from 'helpers/featureFlags/provider'
import referenceMediaTypes from 'helpers/enums/referenceMediaTypes'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import iconStatus from 'helpers/enums/iconStatus'
import errorCodes from 'helpers/enums/errorCodes'

const defaultTimer = {
	value: null,
}

const defaultState = {
	entityUID: '',
	presentationId: '',
	presentationUid: '',
	questions: [],
	isModified: false,
	timer: {
		...defaultTimer,
	},
	studentRecordingAudioEnabled: '0',
	cancelUrl: '',
	isAudioPlayerActive: false,
	isAudioRecorderActive: false,
}

const defaultIcon = {
	id: 0,
	uploadId: 0,
	type: '',
	versions: {},
	link: '',
	status: '',
	message: '',
}

const defaultQuestion = {
	id: '',
	serverId: '',
	icon: {},
	text: '',
	textTouched: true,
	answers: [],
	collapsed: false,
	touched: true,
	status: '',
}

const defaultAnswer = {
	id: '',
	text: '',
	textTouched: true,
}

function initialize(state, action) {
	if (!action.oeqUID) {
		return state
	}
	return {
		...state,
		entityUID: action.oeqUID,
	}
}

function iconCreateInitialize(icon) {
	if (icon.id) {
		return {
			...defaultIcon,
			id: icon.id,
			uploadId: 0,
			type: icon.type,
			versions: icon.versions,
			link: icon.link,
			status: icon.status,
			message: '',
		}
	} else {
		return {
			...defaultIcon,
		}
	}
}

function answerCreateInitialize(answers) {
	return answers.map(answer => ({
		...defaultAnswer,
		id: makeUniqueId(),
		text: answer.text,
	}))
}

function questionCreateInitialize(questions) {
	return questions.map(question => ({
		...defaultQuestion,
		id: makeUniqueId(),
		serverId: question.id,
		text: question.text,
		answers: answerCreateInitialize(question.answers),
		icon: iconCreateInitialize(question.icon),
	}))
}

function initializeSuccess(state, action) {
	return {
		...state,
		presentationId: action.data.presentationId,
		presentationUid: action.data.presentationUid,
		questions: questionCreateInitialize(action.data.questions),
		timer: {
			value: action.data.timer,
		},
		studentRecordingAudioEnabled: action.data.studentRecordingAudioEnabled,
		cancelUrl: action.data.cancelUrl,
		isAudioPlayerActive: shouldShowAudioPlayer(action.data.questions),
	}
}

function questionChange(state, action) {
	const question = state.questions[0]
	return {
		...state,
		isModified: true,
		questions: [{
			...question,
			text: action.value,
			status: 'changed',
			// Reset Exceed Chars prop when changing the question
			hasExceedChars: false,
		}],
	}
}

function questionUpdate(state) {
	const question = state.questions[0]
	return {
		...state,
		questions: [
			{
				...question,
				status: 'saving',
			},
		],
	}
}

function questionUpdateSuccess(state) {
	const question = state.questions[0]
	return {
		...state,
		questions: [
			{
				...question,
				status: '',
			},
		],
	}
}

function addReferenceMediaOpenMenu(state) {
	const question = state.questions[0]
	return {
		...state,
		questions: [
			{
				...question,
				icon: {
					...question.icon,
					message: '',
				},
			},
		],
	}
}

function showReferenceMediaLoading(state, action) {
	const question = state.questions[0]
	return {
		...state,
		questions: [
			{
				...question,
				icon: {
					...question.icon,
					status: 'uploading',
					message: '',
				},
			},
		],
		isAudioRecorderActive: false,
		isAudioPlayerActive: getFlag(featureFlagsTypes.AUDIO_RECORDER_OEQ) &&
			action.files.files[0] && action.files.files[0].type === referenceMediaTypes.AUDIO_RECORDER,
	}
}

function uploaderUploadSuccess(state, action) {
	const question = state.questions[0]
	return {
		...state,
		isModified: true,
		questions: [
			{
				...question,
				icon: {
					...question.icon,
					id: action.icon.id,
					type: action.icon.type,
					versions: action.icon.versions,
					link: action.icon.link,
					status: action.icon.status,
					message: '',
				},
			},
		],
	}
}

function deleteReferenceMedia(state) {
	const question = state.questions[0]
	return {
		...state,
		isModified: true,
		questions: [
			{
				...question,
				icon: {
					...defaultIcon,
				},
			},
		],
	}
}

function validationError(state) {
	return {
		...state,
		questions: state.questions.map(question => ({
			...question,
			textTouched: false,
			touched: false,
			answers: question.answers.map(answer => ({
				...answer,
				textTouched: false,
			})),
		})),
	}
}

function questionUpdateError(state, action) {
	return {
		...state,
		questions: state.questions.map(question => ({
			...question,
			textTouched: false,
			touched: false,
			status: '',
			hasExceedChars: action.error.error_code === errorCodes.EXCEED_MAX_CHARS,
		})),
	}
}

function uploaderUploadError(state, action) {
	const question = state.questions[0]
	return {
		...state,
		questions: [
			{
				...question,
				icon: {
					...question.icon,
					message: action.message,
					status: '',
				},
			},
		],
	}
}

function saveTimer(state, action) {
	//Adding previous timer value to action in case it needs to be reverted if service fails when saving
	action.previous_timer = state.timer
	return {
		...state,
		isModified: true,
		timer: {
			...state.timer,
			value: action.value,
		},
	}
}

function deleteTimer(state, action) {
	//Adding previous timer value to action in case it needs to be reverted if service fails when saving
	action.previous_timer = state.timer
	return {
		...state,
		timer: defaultTimer,
		isModified: true,
	}
}

function revertTimer(state, action) {
	return {
		...state,
		isModified: true,
		timer: action.previous_timer,
	}
}

function toggleStudentRecording(state, action) {
	return {
		...state,
		studentRecordingAudioEnabled: action.value,
	}
}

function processingIconSuccess(state, action) {
	return {
		...state,
		questions: state.questions.map(question => {
			if (question.icon.id === action.icon.id) {
				return {
					...question,
					icon: {
						...question.icon,
						...action.icon,
						message: '',
					},
				}
			} else {
				return question
			}
		}),
	}
}

function processingIconError(state, action) {
	return {
		...state,
		questions: state.questions.map(question => {
			if (question.icon.id === action.icon.id) {
				return {
					...question,
					icon: {
						...question.icon,
						message: action.message,
						status: '',
					},
				}
			} else {
				return question
			}
		}),
	}
}

function finalize() {
	return {
		...defaultState,
	}
}

function openAudioRecorder(state) {
	return {
		...state,
		isAudioRecorderActive: true,
	}
}

function deleteAudioRecorder(state, action) {
	if (action.type === actionTypes.OEQ_AUDIO_RECORDER_DELETE_CONFIRM && action.hasAudioRecorded) {
		return state
	}
	const question = state.questions[0]
	return {
		...state,
		questions: [
			{
				...question,
				icon: {
					...defaultIcon,
				},
			},
		],
		isAudioRecorderActive: false,
	}
}

function shouldShowAudioPlayer(questions) {
	const question = questions[0]
	return getFlag(featureFlagsTypes.AUDIO_RECORDER_OEQ) &&
		question.icon.type === referenceMediaTypes.AUDIO_RECORDER &&
		(question.icon.status === iconStatus.UPLOAD_SUCCESS ||
			question.icon.status === iconStatus.UPLOADED)
}

function deleteAudioPlayer(state) {
	const question = state.questions[0]
	return {
		...state,
		questions: [
			{
				...question,
				icon: {
					...defaultIcon,
				},
			},
		],
		isAudioPlayerActive: false,
	}
}

const oeqReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.OEQ_INITIALIZE_CREATION_TOOL:
		case actionTypes.OEQ_INITIALIZE_STANDALONE:
		case actionTypes.QUICK_LAUNCH_OEQ_INITIALIZE_CREATION_TOOL:
		case actionTypes.QUICK_LAUNCH_OEQ_CREATE_LESSON_SUCCESS:
			return initialize(state, action)
		case actionTypes.OEQ_INITIALIZE_SUCCESS:
			return initializeSuccess(state, action)
		case actionTypes.OEQ_QUESTION_CHANGE:
			return questionChange(state, action)
		case actionTypes.OEQ_QUESTION_SAVE:
			return questionUpdate(state, action)
		case actionTypes.OEQ_QUESTION_UPDATE_SUCCESS:
			return questionUpdateSuccess(state, action)
		case actionTypes.OEQ_QUESTION_UPDATE_ERROR:
			return questionUpdateError(state, action)
		case actionTypes.OEQ_ADD_REFERENCE_MEDIA_OPEN_MENU:
			return addReferenceMediaOpenMenu(state, action)
		case actionTypes.OEQ_UPLOAD_REFERENCE_MEDIA:
			return showReferenceMediaLoading(state, action)
		case actionTypes.OEQ_UPLOADER_UPLOAD_SUCCESS:
			return uploaderUploadSuccess(state, action)
		case actionTypes.OEQ_DELETE_REFERENCE_MEDIA:
			return deleteReferenceMedia(state, action)
		case actionTypes.OEQ_VALIDATION_ERROR:
			return validationError(state, action)
		case actionTypes.OEQ_UPLOAD_REFERENCE_MEDIA_ERROR:
		case actionTypes.OEQ_UPLOADER_VALIDATE_ERROR:
		case actionTypes.OEQ_UPLOADER_UPLOAD_ERROR:
		case actionTypes.OEQ_UPLOADER_VALIDATE_CONTENT_ERROR:
			return uploaderUploadError(state, action)
		case actionTypes.OEQ_SAVE_TIMER:
			return saveTimer(state, action)
		case actionTypes.OEQ_DELETE_TIMER:
			return deleteTimer(state, action)
		case actionTypes.OEQ_TIMER_SAVE_ERROR:
			return revertTimer(state, action)
		case actionTypes.OEQ_STUDENT_RECORDING_TOGGLE:
			return toggleStudentRecording(state, action)
		case actionTypes.PROCESSING_ICON_SUCCESS: {
			return processingIconSuccess(state, action)
		}
		case actionTypes.PROCESSING_ICON_ERROR: {
			return processingIconError(state, action)
		}
		case actionTypes.QUICK_LAUNCH_OEQ_FINALIZE_CREATION_TOOL:
			return finalize()
		case actionTypes.OEQ_AUDIO_RECORDER_SELECTED:
			return openAudioRecorder(state)
		case actionTypes.OEQ_AUDIO_RECORDER_DELETE_CONFIRM:
		case actionTypes.OEQ_AUDIO_RECORDER_DELETE_CONFIRMED:
			return deleteAudioRecorder(state, action)
		case actionTypes.OEQ_AUDIO_PLAYER_DELETE_CONFIRMED:
			return deleteAudioPlayer(state)
		default: return state
	}
}
export default oeqReducer
